<template>
  <div>
        <ctop />

        <div class="help_banner">
            你好！请问您需要什么帮助？
        </div>

        <search />
        <div class="c_content">
            <div class="crumbs">
                <div class="border"></div>
                <div class="now">当前位置：</div>
                <div class="one">帮助中心</div>
            </div>

        </div>

        <div class="help_list">
            <div class="content">
                <div class="title">我猜您想问？</div>
                <div class="list_c">

                    <div class="list" v-for="(vo,i) of list_content" :key="i" @click="gotocontent(vo.id)">
                        <div class="top"></div>
                        <div class="bottom">
                            <div class="name">{{vo.title}}</div>
                            <div class="right">→</div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

        <!-- <div class="fankui">
            <div class="title">问题反馈</div>
            <div class="content">
                <div class="list">
                    <div class="name">联系电话：</div>
                    <el-input v-model="input"></el-input>
                </div>
                <div class="list">
                    <div class="name">反馈内容：</div>
                    <textarea  name=""></textarea>
                </div>
            </div>

            <el-button class="fankuitijiao" type="danger">提交</el-button>
        </div> -->



        <div class="mar"></div>
        <bottom />
        <right />
  </div>
</template>

<script>
import ctop from '@/components/ctop'
import cswiper from '@/components/cswiper'
import search from '@/components/search'
import bottom from '@/components/bottom'
import right from '@/components/right'
export default {
  name: 'Home',
  components: {
      cswiper,
      ctop,
      search,
      bottom,
      right
  },
  data () {
    return {
       currentPage3: 5,
       list_content:[],
       
    }
  },
  computed: {
    
  },
    
  mounted() {
      this.gethelp()
  },
  methods:{
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
        gethelp(){
            this.$http.get('/api/help/index').then((res)=>{
                let callback = res.data
                if(callback.code == 200){
                    this.list_content = callback.data
                }
            }).catch((error) => {
                console.log('获取失败')
            })
        },
        gotocontent(id){
            this.$router.push('/help_content?url=help&id=' + id);
        },
        
        
  },
  
}
</script>

<style lang="scss" scoped>
$zycolor:#CF2C2E;

.c_content{
    width: 100%;
    padding:0 75px;
    box-sizing: border-box;
}
.crumbs{
    display: flex;
    border-bottom: 1px solid #eee;
    padding: 15px 0;
    align-items: center;
    .border{
        height: 20px;
        width: 5px;
        background: #CF2C2E;
        border-radius: 5px;
        margin:0 20px 0 65px;
    }
    .fu{
        margin:0 5px;
    }
}


.mar{
    width: 100%;
    height: 100px;
}
.help_banner{
    height: 600px;
    width: 100%;
    background: url('~@/assets/help.png') no-repeat;
    background-color: #F7F9FA;
    line-height: 400px;
    font-size: 32px;
}

.help_list{
    width: 100%;
    display: flex;
    justify-content: center;
    padding:20px;
    box-sizing: border-box;
    .content{
        width: 70%;
        border-bottom: 1px solid #eee;
        padding-bottom: 50px;
        .title{
            width: 100%;
            text-align: center;
            font-size: 24px;
            margin-bottom: 20px;
        }
        .list_c{
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap:wrap;
            .list{
                width: 30%;
                display: flex;
                // justify-content: space-around;
                flex-direction: column;
                // border-top:1px solid #A1A1A1;
                margin-right:30px;
                padding:30px;
                box-sizing: border-box;
                height: 200px;
                cursor: pointer;
                .top{
                    width: 100%;
                    height: 1px;
                    background: #A1A1A1;
                }
                .bottom{
                    display: flex;
                    justify-content: space-between;
                    margin-top:30px;
                    .name{
                        width: 80%;
                        font-size: 24px;
                        text-align: left;
                    }
                    .right{
                        
                        font-size: 28px;
                        color:#A1A1A1;
                    }
                }
            }
            .list:hover{
                background: #CF2C2E;
                color:#fff;
                .top{
                    background: #fff;
                }
            }
        }
    }    
}

.fankui{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top:40px;
    .title{
        text-align: center;
        font-size: 24px;
    }
    .content{
        width: 70%;
        .list{
            display: flex;
            align-items: center;
            margin-top:40px;
            .name{
                width: 200px;
            }
            .el-input{
                width: 600px;
            }
            textarea{
                width: 600px;
                height: 275px;
                resize:none;
                border: 1px solid #DCDFE6;
                padding:15px;
                box-sizing: border-box;
            }
        }
    }
    .fankuitijiao{
        margin-top:50px;
        background: $zycolor;
        font-size: 18px;
        padding:10px 130px;
    }
}
</style>
